/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PolicyHolder/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import Options from './Options/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PolicyHolder({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/PolicyHolder",
  onChange,
  isInvalid
  
}) {
let assignDetailsOnlyCoverageValueData = fromData.useDataValue({ viewPath,
context: 'assign_details',
path: 'onlyCoverage',
})
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let txCategoryInsuredInsuredInsuranceSubscriptionPersonIdValueData = fromData.useDataValue({ viewPath,
context: 'tx_category_insured',
path: 'insured.insurance_subscription.person_id',
})
let txCategoryInsuredInsuredInsuranceSubscriptionPersonIdChangeData = fromData.useDataChange({ viewPath,
context: 'tx_category_insured',
path: 'insured.insurance_subscription.person_id',
})
let txCategoryInsuredInsuredInsuranceSubscriptionPersonIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'tx_category_insured',
path: 'insured.insurance_subscription.person_id',
validate: fromValidate.numberPositive,
required: true,
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="assign_details.onlyCoverage"
 disabled={assignDetailsOnlyCoverageValueData}
 data="options"
 from={optionsValueData}
 data="tx_category_insured.insured.insurance_subscription.person_id"
 value={txCategoryInsuredInsuredInsuranceSubscriptionPersonIdValueData}
 onChange={txCategoryInsuredInsuredInsuranceSubscriptionPersonIdChangeData}
 data="tx_category_insured.insured.insurance_subscription.person_id"
 validate="/Data/validate.js numberPositive"
 invalid={!txCategoryInsuredInsuredInsuranceSubscriptionPersonIdIsValidData}
 required={true}
 allowEmptyChoice={false}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<div
  data-testid="PolicyHolder.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaSelectOneLabel
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Policyholder"
/>
<Options
  viewPath={`${viewPath}/Options`}
/>
</div>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}